import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// Components
import { PdpRespIconBubbles } from './PdpRespIconBubbles';

import styles from './PdpRespIconBubblesWrapper.scss';

const PdpRespTradeIconBubbles = React.lazy(() =>
    import(/* webpackChunkName: "PdpRespTradeIconBubbles" */ './PdpRespTradeIconBubbles')
);

function PdpRespIconBubblesWrapperComponent(props) {
    const { relayVariables } = props;
    return (
        <div className={styles.wrapper}>
            {relayVariables.isTrade && relayVariables.isClient ? (
                <React.Suspense fallback="">
                    <PdpRespTradeIconBubbles {...props} />
                </React.Suspense>
            ) : (
                <PdpRespIconBubbles {...props} />
            )}
        </div>
    );
}

PdpRespIconBubblesWrapperComponent.propTypes = {
    relayVariables: PropTypes.shape({
        isClient: PropTypes.bool,
        isTrade: PropTypes.bool,
    }).isRequired,
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    skuId: PropTypes.string.isRequired,
    user: PropTypes.object,
};

export const PdpRespIconBubblesWrapper = createFragmentContainer(
    PdpRespIconBubblesWrapperComponent,
    {
        viewer: graphql`
            fragment PdpRespIconBubblesWrapper_viewer on Viewer {
                ...PdpRespIconBubbles_viewer
                ...PdpRespTradeIconBubbles_viewer @include(if: $isTrade)
            }
        `,
        item: graphql`
            fragment PdpRespIconBubblesWrapper_item on Item {
                ...PdpRespIconBubbles_item
                ...PdpRespTradeIconBubbles_item @include(if: $isTrade)
            }
        `,
        user: graphql`
            fragment PdpRespIconBubblesWrapper_user on User {
                ...PdpRespIconBubbles_user
                ...PdpRespTradeIconBubbles_user @include(if: $isTrade)
            }
        `,
    }
);
